export enum StatusCodes {
    Success = 200,
    Redirect = 301,
    TemporaryRedirect = 302,
    Unauthorized = 401,
    NotFound = 404,
    Error = 500
}
